import { isItemIncludedForBAP } from '../../../core/utils';
/*
 * Filters vehicles in the catalog based on their exclusion in a specified province.
 *
 * @param {Array} catalog - The catalog of vehicles to filter.
 * @param {string} provinceCode - The user location province to filter vehicles by.
 * @returns {Array} The filtered models that are not excluded in a specified province.
 *
 */
const removeExcludedItemsInProvinceForBAP = (catalog, provinceCode) => catalog.map(vehicle => {
    var _a, _b, _c;
    return ({
        ...vehicle,
        modelYears: (_c = (_b = (_a = vehicle.modelYears) === null || _a === void 0 ? void 0 : _a.filter(modelYear => isItemIncludedForBAP(modelYear, provinceCode))) === null || _b === void 0 ? void 0 : _b.map(modelYear => {
            var _a, _b;
            return ({
                ...modelYear,
                trims: (_b = (_a = modelYear === null || modelYear === void 0 ? void 0 : modelYear.trims) === null || _a === void 0 ? void 0 : _a.filter(trim => isItemIncludedForBAP(trim, provinceCode))) !== null && _b !== void 0 ? _b : [],
            });
        })) !== null && _c !== void 0 ? _c : [],
    });
});
export default removeExcludedItemsInProvinceForBAP;
